import { render, staticRenderFns } from "./BatchVagueSelectClientName.vue?vue&type=template&id=52b18ecf&scoped=true"
import script from "./BatchVagueSelectClientName.vue?vue&type=script&lang=js"
export * from "./BatchVagueSelectClientName.vue?vue&type=script&lang=js"
import style0 from "./BatchVagueSelectClientName.vue?vue&type=style&index=0&id=52b18ecf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b18ecf",
  null
  
)

export default component.exports